import React from 'react';
import { Route } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../../common/components';

const ViewUserApprover = loadable(() => import('./ViewUserApprover'), {
    fallback: <Loader/>,
});
const UserApproverRoutes = ({ t, alert }) => {
  return [
    <Route
      key="view_user_approver"
      exact
      path="/view/:id/approvers"
      element={<ViewUserApprover t={t} alert={alert} />}
    />
  ];
};
UserApproverRoutes.propTypes = {
  t: PropTypes.func,
  alert: PropTypes.func
};
export default UserApproverRoutes;
